import React from 'react';
import { Button, constants } from '../../Shared/core-components';
import {
   space,
   borderRadius,
   shadow,
   color,
   fontSize,
   lineHeight,
   breakpoint
} from "@core-ds/primitives";
import styled from 'styled-components';
import { Guide } from "./featured_guides_types"

const {
   typography,
} = constants;

const MOBILE = `@media only screen and (max-width: ${breakpoint.sm})`;
const TABLET = `@media only screen and (max-width: ${breakpoint.md})`;

const Highlight = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
`

const Details = styled.div`
   flex: 1;
   margin-left: ${space[7]};

   ${TABLET} {
      margin-left: 0;
   }
`;

const GuideTitle = styled.a`
   display: block;
   :hover {
      text-decoration: none;
   }
   ${typography.title.default}
   color: ${color.gray8};
`;

const ImageContainer = styled.div`
   max-width: 400px;
   flex: 1;

   ${TABLET} {
      height: auto;
      width: 100%;
      margin-bottom: ${space[5]};
   }
`

const Image = styled.img`
   border-radius: ${borderRadius.md};
   box-shadow: ${shadow[2]};
   width: 100%;
`

// https://css-tricks.com/almanac/properties/l/line-clamp/
const Summary = styled.div`
   font-size: ${fontSize[3]};
   ${MOBILE} {
      font-size: ${fontSize[2]};
   }
   line-height: ${lineHeight.normal};
   display: -webkit-box;
   -webkit-box-orient: vertical;
   -webkit-line-clamp: 6;
   line-clamp: 6;
   overflow: hidden;
   text-overflow: ellipsis;
   color: ${color.gray6};
   margin: ${space[4]} 0;
`;

const ViewGuideButton = styled(Button)`
   display: inline-block;

   ${MOBILE} {
      display: none;
   }
`

type GuideHighlightProps = {className?: string, guide: Guide}

function GuideHighlight(props: GuideHighlightProps) {
   let {className, guide}: GuideHighlightProps = props;
   return (
      <Highlight className={className}>
         <ImageContainer>
            <a href={guide.url} aria-label={guide.title}>
               <Image src={guide.image} role="presentation" />
            </a>
         </ImageContainer>
         <Details>
            <GuideTitle href={guide.url}>{guide.title}</GuideTitle>
            <Summary>
               {guide.summary}
            </Summary>
            <ViewGuideButton buttonType="primary" href={guide.url}>
               {_js("View the Guide")}
            </ViewGuideButton>
         </Details>
      </Highlight>
   )
}


export default GuideHighlight;
